export const Version = {
	version: '2.0.5.1151'
};
